import './index.scss'

const TooltipComponent = ({ text }) => {
    return <span class="tooltiptext">{text}</span>
}

export { TooltipComponent }